export const config = {
  title: "G&G Concrete LLC",
  meta: {
    description:
      "G&G Concrete LLC is a Georgia-based concrete contractor delivering quality driveways, patios, sidewalks, slabs/foundations, and retaining walls—with free estimates and dependable workmanship.",
    keywords: [
      "Georgia concrete contractor",
      "concrete driveways GA",
      "patios and sidewalks",
      "retaining walls Georgia",
      "concrete slabs and foundations",
      "G&G Concrete LLC"
    ],
    author: "G&G Concrete LLC",
    canonicalUrl: "https://www.ggconcretellc.com/",
  },
  sections: {
    header: {
      businessName: "G&G Concrete LLC",
    },
    sectionB: {
      heroTitle: "G&G Concrete LLC",
      heroSubtitle: "Laying strong foundations with quality and care",
      learnAboutText: "Get a Free Quote",
      phoneNumber: "7062626416",
      phoneLabel: "(706) 262-6416",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/692096736/photo/concrete-pouring-during-commercial-concreting-floors-of-building.jpg?s=612x612&w=0&k=20&c=LuGlrtanYNsJNatAYczwcEC5QCpJjsGhSFUcora3MfE=",
      cardData: [
        {
          title: "Driveways",
          description: "New pours and replacements built to handle daily traffic and weather.",
        },
        {
          title: "Patios & Sidewalks",
          description: "Clean, level finishes that upgrade outdoor living and accessibility.",
        },
        {
          title: "Slabs & Retaining Walls",
          description: "Durable foundations and wall systems for long‑term stability.",
        },
      ],
      description:
        "Local, reliable concrete work across Georgia—clear communication, careful prep, and finishes made to last.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "From demolition and preparation to forms, pour, finish, and cleanup—we handle your project end‑to‑end.",
      cards: [
        {
          title: "Concrete Driveways",
          description:
            "Tear‑out and replace or new construction with proper grading, base, and control joints.",
          imageSrc:
            "https://media.istockphoto.com/id/157770152/photo/concrete-crew.jpg?s=612x612&w=0&k=20&c=zI0sd8YA0ieZXDuIqOdpF_P-S7WaCDYwB_H5pCXcngw=",
          imageAlt: "Freshly poured driveway",
        },
        {
          title: "Patios & Sidewalks",
          description:
            "Stamped or broom finish options to match your home and traffic needs.",
          imageSrc:
            "https://media.istockphoto.com/id/612258092/photo/smoothing-and-finishing-the-new-concrete-driveway.jpg?s=612x612&w=0&k=20&c=SbHyRKykMPWmbflwk4Zr6Y87Y6BXXkI0uyIgGWoFpuc=",
          imageAlt: "Backyard concrete patio",
        },
        {
          title: "Slabs & Retaining Walls",
          description:
            "Monolithic slabs, equipment pads, and retaining walls built for strength and drainage.",
          imageSrc:
            "https://media.istockphoto.com/id/172982911/photo/masonry-construction-workers-concrete-foundation.jpg?s=612x612&w=0&k=20&c=dQ_WbnYh86WQtX460ItdxFQqWeCBog4DL2QEhG04FqU=",
          imageAlt: "Concrete slab and footing work",
        },
      ],
      otherServicesTitle: "Also Available",
      otherServicesList: [
        "Stairs & Steps",
        "Walkway Extensions",
        "Concrete Repair & Patches",
        "Haul‑away & Site Cleanup",
      ],
    },
    sectionD: {
      aboutTitle: "About G&G Concrete LLC",
      aboutImage: {
        src:
          "https://static.wixstatic.com/media/8e80d6_f02fcde465324c8c837e9e1b5993f8bd~mv2.jpeg/v1/fit/w_339,h_902,q_90,enc_avif,quality_auto/8e80d6_f02fcde465324c8c837e9e1b5993f8bd~mv2.jpeg",
        alt: "Crew finishing a concrete pour",
      },
      aboutText: [
        "At G&G Concrete, we’re committed to strong, reliable, and lasting concrete work. We prepare each site carefully and finish to a standard we’re proud of.",
        "We offer free estimates and keep you updated from start to finish so there are no surprises—just solid results.",
      ],
    },
    sectionE: {
      profileImage: "https://static.wixstatic.com/media/8e80d6_afd8a8d1b40a4aceb8739feac7ea9184~mv2.png/v1/fill/w_487,h_600,al_c,lg_1,q_85,enc_avif,quality_auto/image0.png",
      profileAlt: "G&G Concrete LLC Logo",
      businessName: "G&G Concrete LLC",
      contact: {
        phone: "7062626416",
        phoneLabel: "(706) 262-6416",
        email: "gonzalezggconcretellc@gmail.com",
        website: "https://www.ggconcretellc.com/",
        address: "Georgia, USA",
      },
      socialMedia: {
        facebook: "https://www.facebook.com/p/GG-concrete-LLC-61577734200956/",
      },
    },
    sectionF: {
      address: "Georgia, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3447804.4103764416!2d-85.605166953482!3d32.674051235380776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f44fc34e0546e9%3A0xa0c4c20b9d1d1a0!2sGeorgia%2C%20USA!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus",
    },
  },
};

export default config;
